import loadings from '@/local-shared/mixins/loadings'

export default {
    install: (Vue) => {
        Vue.mixin(loadings)
    }
}